import request from '@/utils/request'

//当前用户可查看的通知公告列表
export function userNoticeList(data) {
	return request({
		url: '/api/noticeUser/userNoticeList',
		method: 'get',
		params: data
	})
}
//全部通知公告列表
export function noticeList(data) {
	return request({
		url: '/api/notice/noticeList',
		method: 'get',
		params: data
	})
}
//查看通知公告(修改已读状态)
export function userIsRead(data) {
	return request({
		url: '/api/noticeUser/userIsRead',
		method: 'put',
		params: data
	})
}
//公告详情
export function noticeGetById(data) {
	return request({
		url: '/api/notice/noticeGetById',
		method: 'get',
		params: data
	})
}
//公告反馈
export function noticeBackSave(data) {
	return request({
		url: '/api/noticeBack/backSave',
		method: 'post',
		data
	})
}
//我的公告反馈
export function studentBackList(data) {
	return request({
		url: '/api/noticeBack/studentBackList',
		method: 'get',
		params: data
	})
}